/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Payment_Terms_Interest_BearingInputs */

const en_clients_payment_terms_interest_bearing = /** @type {(inputs: Clients_Payment_Terms_Interest_BearingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interest-bearing installments`)
};

const pt_br2_clients_payment_terms_interest_bearing = /** @type {(inputs: Clients_Payment_Terms_Interest_BearingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcelamento com juros`)
};

/**
* | output |
* | --- |
* | "Interest-bearing installments" |
*
* @param {Clients_Payment_Terms_Interest_BearingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_payment_terms_interest_bearing = /** @type {((inputs?: Clients_Payment_Terms_Interest_BearingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Payment_Terms_Interest_BearingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_payment_terms_interest_bearing(inputs)
	return pt_br2_clients_payment_terms_interest_bearing(inputs)
});